export const performanceNow = (): number => performance.now();
